var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 18.25V9.5M23.25 7V17C23.25 18.6576 22.5915 20.2473 21.4194 21.4194C20.2473 22.5915 18.6576 23.25 17 23.25H7C5.3424 23.25 3.75269 22.5915 2.58058 21.4194C1.40848 20.2473 0.75 18.6576 0.75 17V7C0.75 5.3424 1.40848 3.75269 2.58058 2.58058C3.75269 1.40848 5.3424 0.75 7 0.75H17C18.6576 0.75 20.2473 1.40848 21.4194 2.58058C22.5915 3.75269 23.25 5.3424 23.25 7Z",
    stroke: "#FAFBFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 18.25V14.1875M10.75 14.1875V9.5M10.75 14.1875C10.75 9.5 18.25 9.5 18.25 14.1875V18.25M5.75 5.7625L5.7625 5.74875",
    stroke: "#FAFBFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/LinkedInIcon.c9398843845666783ec8ef83e1a13855.svg";
export { ForwardRef as ReactComponent };